import NavBar from "app/components/NavBar";
import PropTypes from "prop-types";
import { Footer, PageModal } from "./PageLayout.styles";

export const PageLayout = (props) => {
    return (
        <div id="pageLayout">
            <NavBar />
            {props.children}
            <Footer />

            <div id="divPageSidebar"></div>
            <PageModal id="divPageModal" />
            <div id="divTooltip"></div>
        </div>
    );
};

PageLayout.propTypes = {
    children: PropTypes.node,
};
